export type TimeRangeInput = { start: string; stop: string };

export const TIME_SERIES_GRANULARITIES = [
  'DAY',
  'FIFTEEN_MINUTES',
  'FIVE_MINUTES',
  'HOUR',
  'MINUTE',
  'MONTH',
  'TEN_MINUTES',
  'WEEK',
  'YEAR',
] as const;

export type TimeSeriesGranularity = (typeof TIME_SERIES_GRANULARITIES)[number];

export type TimeSeriesResponse = Array<
  {
    [header: string]: string | null;
  } & {
    labels: Array<string>;
    values: Array<number>;
  }
>;
